<template lang="pug">
    v-card.card(elevation=10 height="60" max-width="250")
      .d-flex.flex-row.align-center(style="height: 100%;")
        div(style="width: 15%; padding: 5px")
          v-icon(size="25" :color="color") {{icon}}
        .d-flex.flex-column.mx-auto
          span {{title}}
          p(:style="`color:${color}; font-size: 16px; font-weight: bold;`") {{valueIcon}} {{value |numberFormat}}
      //- v-row(no-gutters)
        v-col(cols="2")
        v-col(cols="10")
        //- v-divider(vertical)
        //- template(v-if="title === 'Código para compartir'")
          v-card-text
            span#copy-code {{value}}
          v-card-actions
            v-spacer
            v-tooltip(bottom="")
              template(v-slot:activator="{ on, attrs }")
                v-icon.ml-2.mr-1(v-bind="attrs" size="16" @click="copyToClipboard" v-on="on")
                  | mdi-content-copy
              span Copiar
            v-tooltip(bottom="")
              template(v-slot:activator="{ on, attrs }")
                v-icon.ml-2.mr-1(size="16" v-bind="attrs" v-on="on")
                  | mdi-information-outline
              span
                | Comparte este código y cada mes recibirás descuentos hasta del 10% del plan de tu referido
        //- v-col(v-else cols="6").text-end
          span.card__value {{value |numberFormat}} {{valueIcon}}
</template>
<script>
  import * as vars from '@/vars.json'
  export default {
    name: 'MobileCard',

    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },

    props: {
      title: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '0.00',
      },
      valueIcon: {
        type: String,
        default: '#',
      },
      icon: {
        type: String,
        default: undefined,
      },
      color: {
        type: String,
        default: 'success',
      },
    },

    methods: {
      copyToClipboard () {
        const codeToCopy = document.getElementById('copy-code')
        // console.log(codeToCopy)
        const text = codeToCopy.textContent
        // console.log(text)
        navigator.clipboard.writeText(vars.domain2.redirection + 'pages/register/' + text)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    border-radius: 10px;

    &__title{
      font-size: 15px;
      color: #a3a4a5;
      font-weight: 800;
      display: inline-block;
    }

    &__value{
      display: inline-block;
      font-size: 18px;
      color: #a3a4a5;
      font-weight: 800;
      // margin-right: 2rem;
    }
  }
</style>
